export default __webpack_public_path__ + "static/media/LRV.19e65265.png";